import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Es bíblico querer ganar mucho dinero?',
  answer: 'Absolutamente. La Biblia dice que Dios nos da el poder para hacer las riquezas para confirmar su pacto. La riqueza con propósito es una bendición; la avaricia es el pecado. Aquí te enseñamos a ser un buen mayordomo.'
}, {
  question: '¿Necesito saber mucho de tecnología?',
  answer: 'No. Diseñamos este sistema para personas que apenas saben usar WhatsApp. El Bono de IA te mostrará cómo la tecnología trabaja para ti, no al revés.'
}, {
  question: '¿Sirve si apenas estoy llegando a Estados Unidos?',
  answer: '¡Es el mejor momento! Construir tus cimientos correctamente desde el inicio te ahorrará años de errores y miles de dólares en multas o malas decisiones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-20 md:py-28 px-4" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-17" />
        </div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-beige bg-white rounded-sm overflow-hidden shadow-sm" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-20">
                <div className="flex items-center gap-3" data-id="element-21">
                  <HelpCircle className="w-5 h-5 text-gold flex-shrink-0" data-id="element-22" />
                  <span className="font-bold text-charcoal text-lg pr-4" data-id="element-23">
                    {faq.question}
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-24" />
              </button>

              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-26">
                    <div className="px-6 pb-6 pt-2 pl-14 text-brown leading-relaxed" data-id="element-27">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}